import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';

/**
 * Native Network Reachability Service
 */
export const NativeNetwork = {
  /**
   * Get current network connection status
   * @returns {Promise<{ connected: boolean, connectionType: string }>}
   */
  getStatus: async () => {
    if (Capacitor.isNativePlatform()) {
      const status = await Network.getStatus();
      return {
        connected: status.connected,
        connectionType: status.connectionType
      };
    }
    return {
      connected: navigator.onLine,
      connectionType: 'wifi'
    };
  },

  /**
   * Listen to network status changes (online/offline)
   */
  onStatusChange: (callback) => {
    if (Capacitor.isNativePlatform()) {
      return Network.addListener('networkStatusChange', (status) => {
        if (typeof callback === 'function') {
          callback({
            connected: status.connected,
            connectionType: status.connectionType
          });
        }
      });
    }

    const onlineHandler = () => callback && callback({ connected: true, connectionType: 'online' });
    const offlineHandler = () => callback && callback({ connected: false, connectionType: 'none' });

    window.addEventListener('online', onlineHandler);
    window.addEventListener('offline', offlineHandler);

    return {
      remove: () => {
        window.removeEventListener('online', onlineHandler);
        window.removeEventListener('offline', offlineHandler);
      }
    };
  }
};

export default NativeNetwork;
